/* Ghee Culture theme behaviour. No framework; every feature degrades to plain HTML forms and links. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const money = (cents) => window.GC_MONEY ? window.GC_MONEY(cents) : '₹' + (cents / 100).toLocaleString('en-IN');
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));

  /* ——— pixel-based smooth scroll (Lenis). Off under reduced motion; touch keeps native scrolling. ——— */
  let lenis = null;
  let rafId = 0;
  if (!reduce && window.Lenis) {
    lenis = new window.Lenis({
      lerp: 0.075,            // lower = longer, silkier glide
      wheelMultiplier: 0.9,
      touchMultiplier: 1.3,
      smoothWheel: true,
      anchors: { offset: -88 }, // clear the sticky header on #anchor links
      autoRaf: false,
    });
    const loop = (t) => { lenis.raf(t); rafId = requestAnimationFrame(loop); };
    rafId = requestAnimationFrame(loop);
    window.gcLenis = lenis;
  }

  /* ——— reveal on scroll ——— */
  if (!reduce && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('js-motion');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    $$('[data-reveal]').forEach((el) => io.observe(el));
  }

  /* ——— process timeline: the step crossing the middle of the screen lights up; the rail fills as you scroll ——— */
  $$('[data-process]').forEach((sec) => {
    const list = $('[data-process-list]', sec);
    const steps = $$('[data-process-step]', sec);
    const dots = $$('[data-process-dot]', sec);
    const fill = $('[data-process-fill]', sec);
    const current = $('[data-process-current]', sec);
    if (!list || !steps.length) return;
    let active = -1;
    let queued = false;
    const update = () => {
      queued = false;
      const mid = window.innerHeight * 0.55;
      let idx = 0;
      steps.forEach((st, i) => { if (st.getBoundingClientRect().top < mid) idx = i; });
      const r = list.getBoundingClientRect();
      const p = Math.min(1, Math.max(0, (mid - r.top) / r.height));
      if (fill) fill.style.setProperty('--p', p.toFixed(4));
      if (idx === active) return;
      active = idx;
      steps.forEach((st, i) => { st.classList.toggle('is-active', i === idx); st.classList.toggle('is-done', i < idx); });
      dots.forEach((d, i) => { d.classList.toggle('is-active', i === idx); d.classList.toggle('is-done', i < idx); });
      if (current) {
        const label = String(idx + 1).padStart(2, '0');
        if (reduce) { current.textContent = label; return; }
        current.classList.add('is-swap');
        setTimeout(() => { current.textContent = label; current.classList.remove('is-swap'); }, 180);
      }
    };
    const onScroll = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  });

  /* ——— mobile menu ——— */
  const toggle = $('[data-menu-toggle]');
  const mnav = $('#mobile-nav');
  if (toggle && mnav) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      mnav.hidden = open;
    });
  }

  /* ——— quantity steppers ——— */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-step]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    const min = Number(input.min || 0);
    const max = Number(input.max || 99);
    const next = Math.min(max, Math.max(min, Number(input.value || 0) + Number(b.dataset.step)));
    if (next === Number(input.value)) return;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ——— cart drawer ——— */
  const drawer = $('#cart-drawer');
  let lastFocus = null;
  const openDrawer = () => {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    lenis?.stop();
    requestAnimationFrame(() => $('[data-drawer-close]', drawer)?.focus());
  };
  const closeDrawer = () => {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    lenis?.start();
    lastFocus?.focus();
  };
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-drawer-close]')) closeDrawer();
    const opener = e.target.closest('[data-drawer-open]');
    if (opener && drawer) { e.preventDefault(); openDrawer(); }
  });

  /** Swap in fresh section HTML returned by Shopify's Section Rendering API. */
  const applySections = (sections) => {
    if (!sections) return;
    if (sections['cart-drawer'] && drawer) {
      const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const fresh = doc.querySelector('#cart-drawer');
      if (fresh) drawer.innerHTML = fresh.innerHTML;
    }
  };
  const setCount = (n) => $$('[data-cart-count]').forEach((el) => { el.textContent = n; el.hidden = n === 0; });

  const post = async (path, body) => {
    const res = await fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
    return data;
  };

  // Drawer quantity edits: line is 1-based per Shopify's /cart/change.js.
  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (!input || !drawer) return;
    drawer.setAttribute('aria-busy', 'true');
    try {
      const cart = await post('cart/change.js', { line: Number(input.dataset.lineQty), quantity: Number(input.value), sections: ['cart-drawer'] });
      applySections(cart.sections);
      setCount(cart.item_count);
    } catch (err) {
      alertInDrawer(err.message);
    } finally {
      drawer.removeAttribute('aria-busy');
    }
  });
  document.addEventListener('click', async (e) => {
    const rm = e.target.closest('[data-line-remove]');
    if (!rm || !drawer) return;
    e.preventDefault();
    const cart = await post('cart/change.js', { line: Number(rm.dataset.lineRemove), quantity: 0, sections: ['cart-drawer'] }).catch(() => null);
    if (cart) { applySections(cart.sections); setCount(cart.item_count); }
  });
  const alertInDrawer = (msg) => {
    const box = drawer && $('[data-drawer-error]', drawer);
    if (box) { box.textContent = msg; box.hidden = false; }
  };

  /* ——— promo codes (drawer + cart page) ——— */
  const setDiscount = async (code, form) => {
    const err = form && $('[data-promo-error]', form);
    if (err) err.hidden = true;
    try {
      const inDrawer = drawer && drawer.contains(form);
      const cart = await post('cart/update.js', { discount: code, sections: inDrawer ? ['cart-drawer'] : [] });
      if (inDrawer) {
        applySections(cart.sections);
        const match = (cart.discount_codes || []).find((d) => d.code.toUpperCase() === code.toUpperCase());
        if (code && !(match && match.applicable)) alertPromo(`"${code}" isn't a valid code for this cart. Check the spelling and try again.`);
      } else {
        window.location.reload();
      }
    } catch (e) {
      if (code) window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
    }
  };
  const alertPromo = (msg) => {
    const box = drawer && $('[data-promo-error]', drawer);
    if (box) { box.textContent = msg; box.hidden = false; }
  };
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-promo]');
    if (!form) return;
    e.preventDefault();
    const code = $('input[name="code"]', form).value.trim();
    if (code) setDiscount(code, form);
  });
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-promo-remove]');
    if (rm) setDiscount('', rm.closest('[data-promo]'));
  });

  /* ——— jar picker (home "shop" section and product page) ——— */
  $$('[data-picker]').forEach((picker) => {
    const form = $('form[data-add]', picker);
    const qty = $('input[name="quantity"]', form);
    const buyLabel = $('[data-buy-total]', picker);
    const error = $('[data-buy-error]', picker);
    const updateUrl = picker.hasAttribute('data-update-url');
    const sticky = $('[data-sticky-buy]', picker);

    const current = () => $('input[name="id"]:checked', picker);
    const render = () => {
      const r = current();
      if (!r) return;
      const v = r.dataset;
      $$('[data-jar]', picker).forEach((j) => {
        const on = j.dataset.jar === r.value;
        j.classList.toggle('is-on', on);
        const img = $('img', j);
        if (img) img.alt = on ? img.dataset.alt : '';
      });
      $$('[data-numeral]', picker).forEach((n) => { n.textContent = v.numeral; });
      $$('[data-size-tag]', picker).forEach((n) => { n.textContent = v.label; });
      const total = Number(v.price) * Math.max(1, Number(qty.value || 1));
      if (buyLabel) buyLabel.textContent = money(total);
      $$('[data-sticky-label]', picker).forEach((n) => { n.textContent = v.label; });
      $$('[data-sticky-price]', picker).forEach((n) => { n.textContent = `${qty.value} × ${money(Number(v.price))}`; });
      if (updateUrl) {
        const u = new URL(window.location.href);
        u.searchParams.set('variant', r.value);
        window.history.replaceState({}, '', u);
      }
    };
    picker.addEventListener('change', (e) => { if (e.target.matches('input[name="id"], input[name="quantity"]')) render(); });
    render();

    const add = async (e) => {
      e?.preventDefault();
      if (error) error.hidden = true;
      const buttons = $$('[data-add-btn]', picker);
      buttons.forEach((b) => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
      try {
        const data = await post('cart/add.js', {
          items: [{ id: Number(current()?.value), quantity: Math.max(1, Number(qty.value || 1)) }],
          sections: ['cart-drawer'],
          sections_url: window.location.pathname,
        });
        applySections(data.sections);
        const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        setCount(cart.item_count);
        if (drawer) openDrawer(); else window.location.href = root + 'cart';
      } catch (err) {
        if (error) { error.textContent = err.message; error.hidden = false; }
      } finally {
        buttons.forEach((b) => { b.disabled = false; b.removeAttribute('aria-busy'); });
      }
    };
    form.addEventListener('submit', add);
    $$('[data-sticky-add]', picker).forEach((b) => b.addEventListener('click', add));

    // Mobile buy bar once the main button scrolls away; hidden over the footer.
    if (sticky && 'IntersectionObserver' in window) {
      const mainBtn = $('[data-add-btn]', form);
      const footer = $('.site-footer');
      let above = false; let footerOn = false;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.target === mainBtn) above = !en.isIntersecting && en.boundingClientRect.top < 0;
          else footerOn = en.isIntersecting;
        });
        const on = above && !footerOn;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', String(!on));
        $$('button', sticky).forEach((b) => { b.tabIndex = on ? 0 : -1; });
      });
      io.observe(mainBtn);
      if (footer) io.observe(footer);
    }
  });

  /* ——— cart page: quantity changes submit the form (plain POST /cart, works without the drawer) ——— */
  const cartForm = $('[data-cart-form]');
  if (cartForm) {
    let t;
    cartForm.addEventListener('change', (e) => {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(t);
      t = setTimeout(() => cartForm.submit(), 450);
    });
  }

  /* ——— compare switch ——— */
  $$('[data-compare]').forEach((sec) => {
    const sw = $('[role="switch"]', sec);
    const flip = () => {
      const on = sw.getAttribute('aria-checked') !== 'true';
      sw.setAttribute('aria-checked', String(on));
      sec.classList.toggle('is-theirs', on);
      $$('.flip__face--ours', sec).forEach((f) => f.setAttribute('aria-hidden', String(on)));
      $$('.flip__face--theirs', sec).forEach((f) => f.setAttribute('aria-hidden', String(!on)));
      $$('[data-compare-text]', sec).forEach((t) => { t.textContent = on ? t.dataset.theirs : t.dataset.ours; });
    };
    sw.addEventListener('click', flip);
    $$('[data-compare-flip]', sec).forEach((b) => b.addEventListener('click', flip));
  });

  /* ——— kitchen accordion with live caption ——— */
  $$('[data-uses]').forEach((sec) => {
    const items = $$('.uses li', sec);
    const cap = $('[data-uses-cap]', sec);
    const num = $('[data-uses-num]', sec);
    const imgs = $$('[data-uses-img]', sec);
    const set = (i) => items.forEach((li, j) => {
      const on = i === j;
      li.classList.toggle('is-open', on);
      if (imgs[j]) imgs[j].classList.toggle('is-on', on);
      $('button', li).setAttribute('aria-expanded', String(on));
      if (on) { if (cap) cap.textContent = $('.uses__t', li).textContent; if (num) num.textContent = String(j + 1).padStart(2, '0'); }
    });
    items.forEach((li, i) => {
      const b = $('button', li);
      b.addEventListener('click', () => set(i));
      b.addEventListener('mouseenter', () => set(i));
    });
  });

  /* ——— grain magnifier (mouse only; transform + background-position) ——— */
  $$('[data-lens]').forEach((box) => {
    const lens = $('.grain__lens', box);
    box.addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse') return;
      const r = box.getBoundingClientRect();
      const x = e.clientX - r.left; const y = e.clientY - r.top;
      lens.style.opacity = '1';
      lens.style.transform = `translate(${x - 90}px, ${y - 90}px)`;
      lens.style.backgroundPosition = `${(x / r.width) * 100}% ${(y / r.height) * 100}%`;
    });
    box.addEventListener('pointerleave', () => { lens.style.opacity = '0'; });
  });

  /* ——— GSAP scenes (loaded deferred from cdnjs; skipped entirely under reduced motion) ——— */
  const scenes = () => {
    const { gsap, ScrollTrigger } = window;
    if (!gsap || !ScrollTrigger || reduce) return;
    gsap.registerPlugin(ScrollTrigger);
    // Drive Lenis from GSAP's ticker so pinned/scrubbed scenes and the scroll share one frame clock.
    if (lenis) {
      cancelAnimationFrame(rafId);
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add((time) => lenis.raf(time * 1000));
      gsap.ticker.lagSmoothing(0);
    }
    $$('[data-hero]').forEach((hero) => {
      const bg = $('.hero__bg', hero);
      gsap.fromTo(bg, { scale: 1.12 }, { scale: 1, duration: 2.2, ease: 'expo.out' });
      gsap.to(bg, { yPercent: 18, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
      gsap.to($('.hero__content', hero), { yPercent: -12, opacity: 0.2, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
    });
    $$('[data-parallax]').forEach((band) => {
      gsap.fromTo($('.cover-img', band), { yPercent: -8 }, { yPercent: 8, ease: 'none', scrollTrigger: { trigger: band, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
    const mm = gsap.matchMedia();
    mm.add('(min-width: 768px)', () => {
      const undo = [];
      // Sticky jar stage (home shop + product page): the big size numeral drifts with the scroll while the stage is held.
      $$('.stage').forEach((stage) => {
        const num = $('.stage__numeral', stage);
        if (!num) return;
        gsap.fromTo(num, { yPercent: -6 }, {
          yPercent: 24, ease: 'none',
          scrollTrigger: { trigger: stage.closest('.buy') || stage.parentElement, start: 'top top', end: 'bottom bottom', scrub: 0.35 },
        });
      });
      return () => undo.forEach((f) => f());
    });
  };
  if (window.gsap) scenes(); else window.addEventListener('load', scenes, { once: true });

  /* ——— marquee follows scroll speed: speeds up with the wheel, eases back to its cruise pace ——— */
  if (lenis) {
    const runs = $$('.marquee').map((m) => m.getAnimations?.()[0]).filter(Boolean);
    if (runs.length) {
      let rate = 1; let target = 1;
      lenis.on('scroll', ({ velocity }) => { target = 1 + Math.min(Math.abs(velocity) / 6, 4); });
      const tick = () => {
        target += (1 - target) * 0.04;      // decay back to cruise
        rate += (target - rate) * 0.12;     // smooth the change so it never jumps
        runs.forEach((a) => { a.playbackRate = rate; });
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }
  }
})();
